import React from 'react';
import PropTypes from 'prop-types';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrSimpleTextTag = ({ title, value, color }) => (
  <SrBox borderRadius="14px" backgroundColor={color} padding="16px 18px 18px">
    <SrText
      font="greycliff"
      size="16"
      weight="700"
      lineHeight="21px"
      color="blueGreycliff"
      display="block"
      align="center"
    >
      {title}
    </SrText>
    <SrBox marginTop="8px">
      <SrText
        font="greycliff"
        size="30"
        weight="800"
        lineHeight="25px"
        color="blueGreycliff"
        display="block"
        align="center"
      >
        {value}
      </SrText>
    </SrBox>
  </SrBox>
);

SrSimpleTextTag.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  color: PropTypes.string,
};

SrSimpleTextTag.defaultProps = {
  color: '#f1f1f1',
};

SrSimpleTextTag.displayName = 'SrSimpleTextTag';

export default SrSimpleTextTag;
